import Newsletters from "./Newsletters";

export default Newsletters;
